import Lottie from "lottie-web";
import { isNil } from "lodash";
import animationData from "../../asset/lotties/loading_animation.json";
import { useSelectTheme } from "../../store";
import { CSSProperties, useEffect, useRef } from "react";
import { BtnPaddingSize } from "../atoms";

export interface PreparingDataViewProps {
  estimatedTimeRemaining?: string;
  style?: CSSProperties;
  onClick?: () => void;
}

export const PreparingDataView = (props: PreparingDataViewProps) => {
  const { estimatedTimeRemaining, style, onClick } = props;
  const isStatic = isNil(onClick);

  const { color, fontSize, fontWeight, borderRadius, pad } = useSelectTheme();

  const animRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (!animRef.current) return;
    const anim = Lottie.loadAnimation({
      container: animRef.current,
      renderer: "svg",
      loop: true,
      autoplay: true,
      animationData: animationData,
    });
    return () => anim.stop();
  }, []);

  const contentText = (() => {
    let base = "Preparing Your Data";
    if (estimatedTimeRemaining) {
      base = `${base} (~${estimatedTimeRemaining} left)`;
    }
    return base;
  })();

  return (
    <div
      onClick={() => onClick?.()}
      css={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: BtnPaddingSize.medium,
        gap: pad.small,
        background: color.white,
        borderRadius: borderRadius.default,
        border: `1px solid ${color.textIcon.link}`,
        cursor: isStatic ? "default" : "pointer",
        ":hover": isStatic
          ? undefined
          : {
              background: color.surface.hover.hoverWhiteBg,
            },
        ...style,
      }}
    >
      <div ref={animRef} css={{ width: "40px", height: "40px", margin: "-12px" }} />
      <span
        css={{
          fontSize: fontSize.h6,
          fontWeight: fontWeight.thick,
          color: color.textIcon.link,
        }}
      >
        {contentText}
      </span>
    </div>
  );
};
